import { Button, Form } from 'antd';
import styled from 'styled-components';
import { InterestFineType } from './types';

export const InterestFineFormContainer = styled(Form<InterestFineType>)`
	padding: 0;
	margin: 0;
	display: flex;
	flex-direction: column;
`;

export const InterestFineFormItem = styled(Form.Item)`
	label {
		font-weight: 400 !important;
		font-size: 1rem !important;
		color: ${p => p.theme.text} !important;
	}
`;

export const ForwardButton = styled(Button)`
	display: flex;
	align-items: center;
	height: 45px;
	gap: 0.3rem;
	width: 100%;

	p {
		font-size: 18px;
		color: white;
		padding-bottom: 1px;
		margin: 0 auto;
	}

	&:disabled {
		background-color: ${p => p.theme.primaryOpacity};
		border-color: ${p => p.theme.primaryOpacity};
		p {
			color: ${p => p.theme.primary};
			opacity: 0.5;
		}

		svg {
			color: ${p => p.theme.primary};
			opacity: 0.5;
		}
	}
`;

export const CancelButton = styled(Button)`
	display: flex;
	align-items: center;
	height: 45px;
	gap: 0.3rem;
	width: 100%;
	margin-top: 1rem;
	background-color: transparent;
	border-color: transparent;
	box-shadow: none;

	p {
		font-size: 18px;
		color: ${p => p.theme.primary};
		padding-bottom: 1px;
		margin: 0 auto;
	}

	&:disabled {
		background-color: transparent;
		border-color: transparent;
		p {
			color: ${p => p.theme.primary};
		}

		svg {
			color: ${p => p.theme.primary};
		}
	}
`;
